import type { IUiPermissions } from 'modules/login/model/login.dto'
import { defineStore } from 'pinia'

export const usePermissionsStore = defineStore('permissions', () => {
  const showAiKnowledgeBase = ref(false)
  const showOutboxQueue = ref(false)
  const showExpressExpiringOrders = ref(false)
  const showAdminPanel = ref(false)

  function setPermissions(data: IUiPermissions) {
    showAiKnowledgeBase.value = data.show_ai_knowledge_base
    showOutboxQueue.value = data.show_outbox_queue ?? false
    showExpressExpiringOrders.value = data.show_express_expiring_orders ?? false
    showAdminPanel.value = data.show_admin_panel ?? false
  }

  function resetPermissions() {
    showAiKnowledgeBase.value = false
    showOutboxQueue.value = false
    showExpressExpiringOrders.value = false
    showAdminPanel.value = false
  }

  return {
    showAiKnowledgeBase,
    showOutboxQueue,
    showExpressExpiringOrders,
    showAdminPanel,
    setPermissions,
    resetPermissions,
  }
}, { persist: true })
